import axios from "axios";
import * as languageTranslatorTypes from "../../types/admin/languageTranslator";

//Get Language Translator
export const langaugeTanslatorAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: languageTranslatorTypes.GET_LANGUAGE_TRANSLATORS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/language/translator/${formData}`,
        config
      );
      // console.log(data?.data?.company);
      dispatch({
        type: languageTranslatorTypes.GET_LANGUAGE_TRANSLATORS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: languageTranslatorTypes.GET_LANGUAGE_TRANSLATORS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
